<app-header></app-header>

<div class="so-shell">
  <div class="so-grid">

    <!-- ===== Left: you + shortcuts ===== -->
    <aside class="so-rail so-rail--left" aria-label="Social shortcuts">
      <div class="so-card so-me">
        <div class="so-me-cover"></div>
        <div class="so-me-body">
          @if (hub.profile) {
            <a class="so-avatar so-avatar--lg" [routerLink]="['/social-profile', hub.profile.author.id]" aria-label="Your profile">
              @if (hub.profile.author.avatar) {
                <img [src]="imageUrl(hub.profile.author.avatar)" alt="" (error)="hub.profile.author.avatar = null" />
              } @else {
                {{ initials(hub.profile.author.name) }}
              }
            </a>
            <p class="so-me-name">{{ hub.profile.author.name }}</p>
            @if (hub.profile.handle) {
              <span class="so-me-handle">&#64;{{ hub.profile.handle }}</span>
            }
            <div class="so-me-stats">
              <a [routerLink]="['/social-profile', hub.profile.author.id]"><strong>{{ hub.profile.followers_count }}</strong>followers</a>
              <a [routerLink]="['/social-profile', hub.profile.author.id]"><strong>{{ hub.profile.following_count }}</strong>following</a>
            </div>
          } @else {
            <span class="so-avatar so-avatar--lg so-skel"></span>
            <span class="so-skel" style="height: 14px; width: 70%; margin-top: 12px"></span>
            <span class="so-skel" style="height: 10px; width: 45%; margin-top: 8px"></span>
          }
        </div>
      </div>

      <nav class="so-card so-nav" aria-label="Social">
        <a routerLink="/social-feed" [class.is-active]="active === 'feed'"><i class="fa fa-home"></i> Feed</a>
        <a routerLink="/communities" [class.is-active]="active === 'communities'">
          <i class="fa fa-users"></i> Communities
          @if (hub.inviteCount) {
            <span class="so-count" title="Community invites">{{ hub.inviteCount }}</span>
          }
        </a>
        <a routerLink="/social-notifications" [class.is-active]="active === 'notifications'">
          <i class="fa fa-bell"></i> Notifications
          @if (hub.unreadNotifications) {
            <span class="so-count">{{ hub.unreadNotifications }}</span>
          }
        </a>
        <a routerLink="/social-messages" [class.is-active]="active === 'messages'">
          <i class="fa fa-envelope"></i> Messages
          @if (hub.unreadMessages) {
            <span class="so-count">{{ hub.unreadMessages }}</span>
          }
        </a>
        @if (hub.profile) {
          <a [routerLink]="['/social-profile', hub.profile.author.id]" [class.is-active]="active === 'profile'"><i class="fa fa-user"></i> Profile</a>
        }
      </nav>

      <div class="so-card so-card-pad">
        <h3 class="so-card-title">Your communities <a routerLink="/communities" [queryParams]="{ tab: 'mine' }">All</a></h3>
        @if (hub.communities.length) {
          <ul class="so-links">
            @for (c of hub.communities; track c.id) {
              <li>
                <a [routerLink]="['/communities', c.slug]">
                  <span class="so-tile">
                    @if (c.image) { <img [src]="imageUrl(c.image)" alt="" /> } @else { {{ initials(c.name) }} }
                  </span>
                  <span>{{ c.name }}</span>
                </a>
              </li>
            }
          </ul>
        } @else if (hub.loaded) {
          <p class="so-muted">You haven't joined any yet. <a routerLink="/communities">Find one</a>.</p>
        }
      </div>

      @if (hub.groups.length) {
        <div class="so-card so-card-pad">
          <h3 class="so-card-title">Map groups</h3>
          <ul class="so-links">
            @for (g of hub.groups; track g.id) {
              <li><a [routerLink]="['/social-group', g.id]"><span class="so-tile"><i class="fa fa-map-o"></i></span><span>{{ g.name }}</span></a></li>
            }
          </ul>
        </div>
      }

      @if (hub.gameGroups.length) {
        <div class="so-card so-card-pad">
          <h3 class="so-card-title">Games</h3>
          <ul class="so-links">
            @for (g of hub.gameGroups; track g.id) {
              <li><a [routerLink]="['/social-game-group', g.id]"><span class="so-tile"><i class="fa fa-gamepad"></i></span><span>{{ g.name }}</span></a></li>
            }
          </ul>
        </div>
      }
    </aside>

    <!-- ===== Center: the page ===== -->
    <main class="so-center">
      <nav class="so-mobile-nav" aria-label="Social">
        <a routerLink="/social-feed" [class.is-active]="active === 'feed'"><i class="fa fa-home"></i> Feed</a>
        <a routerLink="/communities" [class.is-active]="active === 'communities'"><i class="fa fa-users"></i> Communities
          @if (hub.inviteCount) { <span class="so-count">{{ hub.inviteCount }}</span> }</a>
        <a routerLink="/social-notifications" [class.is-active]="active === 'notifications'"><i class="fa fa-bell"></i> Notifications
          @if (hub.unreadNotifications) { <span class="so-count">{{ hub.unreadNotifications }}</span> }</a>
        <a routerLink="/social-messages" [class.is-active]="active === 'messages'"><i class="fa fa-envelope"></i> Messages
          @if (hub.unreadMessages) { <span class="so-count">{{ hub.unreadMessages }}</span> }</a>
        @if (hub.profile) {
          <a [routerLink]="['/social-profile', hub.profile.author.id]" [class.is-active]="active === 'profile'"><i class="fa fa-user"></i> Profile</a>
        }
      </nav>
      <ng-content></ng-content>
    </main>

    <!-- ===== Right: what's new ===== -->
    <aside class="so-rail so-rail--right" aria-label="What's new">
      <div class="so-card so-card-pad">
        <h3 class="so-card-title">
          Notifications
          @if (hub.unreadNotifications) {
            <button type="button" (click)="markAllRead()">Mark all read</button>
          }
        </h3>
        @if (recentNotifications.length) {
          <ul class="so-notes">
            @for (n of recentNotifications; track n.id) {
              <li>
                <button type="button" [class.is-unread]="!n.is_read" (click)="openNotification(n)">
                  <span class="so-note-text">{{ n.message }}</span>
                  <span class="so-faint">{{ timeAgo(n.created_at) }}</span>
                </button>
              </li>
            }
          </ul>
          <a class="so-rail-link" routerLink="/social-notifications">See all notifications</a>
        } @else if (hub.loaded) {
          <p class="so-muted">You're all caught up.</p>
        } @else {
          <span class="so-skel" style="height: 12px; margin: 8px 0"></span>
          <span class="so-skel" style="height: 12px; width: 70%"></span>
        }
      </div>

      @if (hub.inviteCount) {
        <a class="so-card so-card-pad so-invite-card" routerLink="/communities" [queryParams]="{ tab: 'invites' }">
          <span class="so-empty-icon"><i class="fa fa-envelope-open"></i></span>
          <span>
            <strong>{{ hub.inviteCount }} community invite{{ hub.inviteCount === 1 ? '' : 's' }}</strong>
            <span class="so-faint">Accept or decline them</span>
          </span>
        </a>
      }

      <div class="so-card so-card-pad">
        <h3 class="so-card-title">Discover communities <a routerLink="/communities">Browse</a></h3>
        @if (hub.suggested.length) {
          <ul class="so-links">
            @for (c of hub.suggested; track c.id) {
              <li>
                <a [routerLink]="['/communities', c.slug]">
                  <span class="so-tile">
                    @if (c.image) { <img [src]="imageUrl(c.image)" alt="" /> } @else { {{ initials(c.name) }} }
                  </span>
                  <span>{{ c.name }}<br /><small class="so-faint">{{ c.member_count }} member{{ c.member_count === 1 ? '' : 's' }}</small></span>
                </a>
              </li>
            }
          </ul>
        } @else if (hub.loaded) {
          <p class="so-muted">No new communities right now.</p>
        }
        <a class="btn btn-dark so-rail-btn" routerLink="/communities/new"><i class="fa fa-plus"></i> Start a community</a>
      </div>
    </aside>
  </div>
</div>

<app-footer></app-footer>
